import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoGanttDependencyDataSourceMixin from './KendoGanttDependencyDataSourceMixin'

export default {
    name: 'kendo-ganttdependencydatasource',
    mixins: [ KendoGanttDependencyDataSourceMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoGanttDependencyDataSource/index.js